
/**
 * Creates a new reducer using less boilerplate than with the default case syntax.
 *
 * @param {Object} actions Mapping of { [ACTION]: (state, action) => state }
 * @return {Function} Reducer which can be used with Redux
 */
export default function makeReducer(actions) {

    let defaultState;

    if ( actions.default ) {
        defaultState = actions.default();
    } else {
        throw new Error("makeReducer: No default action has been defined");
    }

    let keys = Object.keys(actions);

    return (state=defaultState, action) => {
        for (var i = 0; i < keys.length; i++) {
            if ( keys[i] === action.type ) {
                return actions[action.type](state, action);
            }
        }
        return state;
    }
}



/** WEBPACK FOOTER **
 ** ../ibe/src/makeReducer.js
 **/